import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  showModal() {
    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  hideModal() {
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = "auto"
  }

  // ESCキーでモーダルを閉じる
  connect() {
    this.boundHandleKeyup = this.handleKeyup.bind(this)
    document.addEventListener("keyup", this.boundHandleKeyup)
  }

  disconnect() {
    document.removeEventListener("keyup", this.boundHandleKeyup)
    document.body.style.overflow = "auto"
  }

  handleKeyup(event) {
    if (event.key === "Escape") {
      this.hideModal()
    }
  }

  // モーダル背景クリックで閉じる
  clickOutside(event) {
    if (event.target === this.modalTarget) {
      this.hideModal()
    }
  }
}
